import { createFileRoute } from '@tanstack/react-router';
import { AuthTemplate } from '@/components/auth/auth-template';
import { ForgotPasswordForm } from '@/features/auth/forgot-password-form';

export const Route = createFileRoute('/forgot-password')({
  component: () => (
    <AuthTemplate>
      <ForgotPasswordForm />
    </AuthTemplate>
  ),
});
